import { useState, useEffect } from 'react';
import { useUserService } from 'src/context';
import { User } from 'src/types';
import { useUserId } from 'src/context';

const useUser = () => {
  const userService = useUserService();
  const { userId } = useUserId();
  const [user, setUser] = useState<User>();

  useEffect(() => {
    const fetchUser = async (userId: string) => {
      try {
        const user = await userService.getUserById(userId);
        setUser(user);
      } catch (err) {
        console.warn('Error fetching user data');
      }
    };

    if (userId) {
      fetchUser(userId);
    }
  }, [userId, userService]);

  return { user };
};

export { useUser };
